import * as React from "react";

import {Select, Tabs} from "antd";
import {ISelectedOption, ISelectOption} from "../../components/FuseSelect";
import {IBannerTemplate} from "../../store/banner/template/types";
import {AdLabel, Ads, CampaignWithAds} from "../../store/organizations/types";
import {
    modifyingActiveBannerTemplateAction,
} from "../../store/banner/template/actions";
import {
    ISetActiveCampaignIdsActionPayload,
    ISetActiveOrganizationIdActionPayload, setActiveCampaignIdsAction, setActiveOrganizationIdAction
} from "../../store/organizations/actions";
import remergeCondition from "../../firebase/conditions";
import {AppState} from "../../store";
import {
    selectActiveBannerTemplate,
    selectActiveMasterBannerTemplate
} from "../../store/banner/template/selectors";
import {
    areAdsFetched,
    areCampaignsFetched,
    areOrganizationsFetched, selectAdLabels, selectAdLabelsByActiveCampaignIds, selectVisibleAdsByActiveCampaignIds,
    selectVisibleCampaignOptions, selectVisibleOrganizationsOptions
} from "../../store/organizations/selectors";
import {Dispatch} from "redux";
import {withAuthorization} from "../../firebase/withAuthorization";
import {connect} from "react-redux";
import {SelectValue} from "antd/lib/select";
import {IdObjectsWithId} from "../../utils";
import {MonacoDiffEditor} from "react-monaco-editor";

const {Option} = Select;
const {TabPane} = Tabs;

interface IOwnProps {
    visible: boolean;
}

export interface IOwnDispatchProps {
    onCancel?: () => void
    onLinksChange?: () => void
}

interface IStateProps {
    activeBannerTemplate: IBannerTemplate,
    activeMasterBannerTemplate?: IBannerTemplate,
    areOrganizationsFetched: boolean;
    areCampaignsFetched: boolean;
    organizationsOptions: ISelectOption[];
    campaignsOptions: ISelectOption[];
    campaignsWithAds: IdObjectsWithId<CampaignWithAds>;
    areAdsFetched: boolean;
    adLabels: IdObjectsWithId<AdLabel>;
    visibleLabelIds: string[]
}

interface IDispatchProps {
    modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => void;
    setActiveOrganizationId: (params: ISetActiveOrganizationIdActionPayload) => void
    setActiveCampaignIds: (params: ISetActiveCampaignIdsActionPayload) => void
}

type IProps = IOwnProps & IOwnDispatchProps & IStateProps & IDispatchProps


interface IState {
    activeKey: string;
}

class TemplateDiffs extends React.Component<IProps, IState> {
    state: IState;

    constructor(props: IProps) {
        super(props);
        this.state = {
            activeKey: "1"
        }
    }

    handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel()
        }
    };

    handleOk = () => {
        if (this.props.onLinksChange) {
            this.props.onLinksChange()
        }
    };

    onOrganizationSelect = (selectedValue: SelectValue, option: ISelectedOption) => {
        let organizationId: string = selectedValue as string;
        this.props.setActiveOrganizationId({organizationId: organizationId});
        this.props.setActiveCampaignIds({campaignIds: []});
        this.props.modifyingActiveBannerTemplate({organizationId: organizationId, campaignIds: [], adLabelIds: []});
    };

    onCampaignChange = (selectedValue: SelectValue) => {
        let campaignIds: string[] = selectedValue as string[];
        this.props.setActiveCampaignIds({campaignIds: campaignIds})
        this.props.modifyingActiveBannerTemplate({campaignIds: campaignIds});
    };

    onAdsChange = (selectedValue: SelectValue) => {
        let adLabelIds: string[] = selectedValue as string[];
        this.props.modifyingActiveBannerTemplate({adLabelIds: adLabelIds})
    };

    onTemplateChange = () => {
    }

    onTemplateDiffChange = () => {
    }

    options = {
        selectOnLineNumbers: true
    };

    render() {
        const adsTabPanes = Object.keys(this.props.campaignsWithAds.byId).map(
            cId => {
                const campaign = this.props.campaignsWithAds.byId[cId]
                return (
                    <TabPane tab={`[${cId}] ${campaign.name}`} key={cId}>
                        <Tabs
                            animated={false}
                            size="small"
                            onChange={(activeKey: string) => this.setState({activeKey: activeKey})}
                        >
                            <TabPane tab={"Custom Code"} key={"1"}>
                                <div style={{height: "100%", overflow: "auto"}}>
                                    Live v.s. Template
                                    <MonacoDiffEditor
                                        height="55vh"
                                        language={"js"}
                                        original={campaign.code}
                                        value={this.props.activeBannerTemplate.customCode}
                                        options={this.options}
                                        onChange={this.onTemplateChange}
                                    />
                                </div>
                            </TabPane>
                            <TabPane tab={"Ads"} key={"2"}>
                                <Tabs animated={false} size="small">
                                    {campaign.ads.map((ad: Ads) => {
                                        const selectedAdLabelIds = this.props.activeBannerTemplate.adLabelIds
                                        if (!selectedAdLabelIds || !selectedAdLabelIds.includes(ad.label_id.toString())) {
                                            return null
                                        }
                                        let adName = `[${ad.id}] `;
                                        if (this.props.adLabels.byId[ad.label_id]) {
                                            adName += this.props.adLabels.byId[ad.label_id].name
                                        }
                                        return (
                                            <TabPane tab={adName} key={ad.id}>
                                                Live v.s. Template
                                                <MonacoDiffEditor
                                                    height="55vh"
                                                    language={"html"}
                                                    original={ad.template_value}
                                                    value={this.props.activeBannerTemplate.template}
                                                    options={this.options}
                                                    onChange={this.onTemplateChange}
                                                />
                                            </TabPane>
                                        )
                                    })}
                                </Tabs>
                            </TabPane>
                        </Tabs>
                    </TabPane>
                )
            }
        )

        const campaignIdsOptions = this.props.campaignsOptions.map((c: ISelectOption) => (
            <Option key={c.value}>{c.text}</Option>
        ));


        return (
            <Tabs animated={false} size="small">
                {adsTabPanes}
            </Tabs>
        )
    }
}

const authCondition = (authUser: any) => remergeCondition(authUser);

const mapStateToProps = (state: AppState, props: IOwnProps): IStateProps => ({
    activeBannerTemplate: selectActiveBannerTemplate(state),
    activeMasterBannerTemplate: selectActiveMasterBannerTemplate(state),
    areOrganizationsFetched: areOrganizationsFetched(state),
    areCampaignsFetched: areCampaignsFetched(state),
    campaignsOptions: selectVisibleCampaignOptions(state),
    organizationsOptions: selectVisibleOrganizationsOptions(state),
    campaignsWithAds: selectVisibleAdsByActiveCampaignIds(state),
    areAdsFetched: areAdsFetched(state),
    adLabels: selectAdLabels(state),
    visibleLabelIds: selectAdLabelsByActiveCampaignIds(state),
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => dispatch(modifyingActiveBannerTemplateAction({bannerTemplate: value})),
        setActiveOrganizationId: (params: ISetActiveOrganizationIdActionPayload) => dispatch(setActiveOrganizationIdAction(params)),
        setActiveCampaignIds: (params: ISetActiveCampaignIdsActionPayload) => dispatch(setActiveCampaignIdsAction(params)),
    };
};

export default withAuthorization(authCondition)(connect(
    mapStateToProps,
    mapDispatchToProps,
)(TemplateDiffs));



